import React, { useState, useEffect, useRef} from "react";
import {
  FiPaperclip,
  FiMail,
  FiBookmark,
  FiMessageCircle,
  FiAlertTriangle,
} from "react-icons/fi";
import { AiOutlineFormatPainter } from "react-icons/ai";
import { FaWhatsapp, FaUserCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import SkillBadge from "../../../common/skillBadge";
import ResumeModal from "../../../common/resumeModal";
import EmailModal from "../../../common/emailModal";
import WhatsAppModal from '../../../common/whatsAppModal';
import { generateRequestId, getInitials } from "../../../common/common";
import { RecruiterApi } from "../../../supports/recruiterApi";
import CommentModal from "../../../common/candidateCommentModal";
import FillMandatoryFieldsModal from "./fillMandatoryFieldsModal";
import { resumeUpload } from "../../../supports/resumeUpload";
import { FaBookmark as FaBookmarkFilled } from "react-icons/fa";
import { useToast } from "../../../common/toastSystem";
import JobSelectionModal from "../../../common/jobSelectionModal";
import CustomDropdown from "../../../common/dropdown";
import unifiedAuthManager from "../../../services/unifiedAuthManager";
import { createPortal } from "react-dom";
import useDropdownData from "../../candidateProfiler/profilerEditingPage/useDropDownData";
import { FileText, Pencil } from "lucide-react";
const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];
const SECTOR_REQUIRED_ERROR = "Sector is mandatory. Please select at least one sector.";
const FORMATTED_CV_TYPES = [
  { label: "Standard", value: "standard" },
  { label: "Confidential", value: "confidential" },
];

const CandidateItem = ({
  candidate,
  pageType = "standard",
  disableSubmitToAM = false,
  onMatchingCandidateClick,
  query,
  searchType,
  mph_jobid,
  job_id,
  jobDetails,
  onTagAction,
  onSubmitCandidate,
  onUpdateCandidate,
  selectedIds = [],
  isTyping = false,
  onCandidateUpdateFilter,
  onMoveToUploadedTab = () => {},
  onSelectionChange = () => {},
   isLastIndex,
}) => {
  const isMatchingPage = pageType === "matching";
  const iconButtonStyles =
    "h-8 w-8 flex items-center justify-center border border-gray-200 rounded-full text-gray-500 hover:bg-gray-100 hover:text-emerald-600 transition-colors";
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [savedComment, setSavedComment] = useState("");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [resumeUrl, setResumeUrl] = useState(null);
  const [resumeLoading, setResumeLoading] = useState(false);
  const [resumeError, setResumeError] = useState("");
  const [resumeFileType, setResumeFileType] = useState(null);
  const [expanded, setExpanded] = useState(true);
  const [showCVModal, setShowCVModal] = useState(false);
  const [showFormattedCVTypeModal, setShowFormattedCVTypeModal] = useState(false);
  const [formattedCVType, setFormattedCVType] = useState("");
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [validationError, setValidationError] = useState(null);
  const [showFillModal, setShowFillModal] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [fillSaving, setFillSaving] = useState(false);
  const [fillSaveError, setFillSaveError] = useState("");
  const [showAllSkills, setShowAllSkills] = useState(false);
  const [submittingToAM, setSubmittingToAM] = useState(false);
  const [candidateData, setCandidateData] = useState(candidate);
  const [isBookmarked, setIsBookmarked] = useState(!!candidate.is_tagged);
  const [bookmarkLoading, setBookmarkLoading] = useState(false);
  const [resumeCandidateData, setResumeCandidateData] = useState(candidate);
  const skills = candidate.skills || [];
  const visibleSkills = showAllSkills ? skills : skills.slice(0, 3);
  const hiddenCount = Math.max(0, skills.length - 3);
  const [formattedCVUrl, setFormattedCVUrl] = useState(null);
  const [formattedCVLoading, setFormattedCVLoading] = useState(false);
  const [formattedCVError, setFormattedCVError] = useState('');
  const [showWarningTooltip, setShowWarningTooltip] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [isAllJobsLoading, setIsAllJobsLoading] = useState(false);
  const [currentJobs, setCurrentJobs] = useState([]);
  const [showJobsModal, setShowJobsModal] = useState(false);
  const [mphJobId, setMphJobId] = useState('');
  const [selectedJobForApplicant, setSelectedJobForApplicant] = useState('');
  const [collapsed, setCollapsed] = useState(pageType === "matching");
  const user = unifiedAuthManager.getUnifiedUser();
  // Email
  const [isHovering, setIsHovering] = useState(false);
  const isSelected = Array.isArray(selectedIds) && selectedIds.some(item => item.id === candidate.id)
  const [emailType, setEmailType] = useState('');

  //whatsapp Modal
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  const [showResumeEditModal, setShowResumeEditModal] = useState(false);
  const [resumeEditCandidate, setResumeEditCandidate] = useState(null);
  const [resumeEditLoading, setResumeEditLoading] = useState(false);
  const [resumeEditError, setResumeEditError] = useState("");
  const [resumeEditSaving, setResumeEditSaving] = useState(false);
  const [resumeEditForm, setResumeEditForm] = useState({
    phone: "",
    gender: "",
    location: "",
    nationality: "",
    languages: [],
    sectors: [],
    date_of_birth: "",
  });
  const [countryGuidOptions, setCountryGuidOptions] = useState([]);
  const [countryGuidLoading, setCountryGuidLoading] = useState(false);
  const [resumeEditFormInitialized, setResumeEditFormInitialized] = useState(false);
  const { sectors, languages, fetchSectors, fetchLanguages } = useDropdownData();
  const todayDateForInput = new Date().toISOString().split("T")[0];
  const isSectorRequiredError = resumeEditError === SECTOR_REQUIRED_ERROR;

  const modalSizeClass = expanded
    ? "w-full h-full max-w-none max-h-none"
    : "w-full h-full max-w-none max-h-none";
  const modalPaddingClass = expanded ? "p-2 md:p-6" : "p-2 md:p-6";
  const modalContainerClass = expanded
    ? "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    : "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30";
  const gridColsClass = expanded
    ? "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6"
    : "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6";
  const iframeHeightClass = expanded ? "h-[80vh] md:h-[85vh]" : "h-[80vh] md:h-[85vh]";

  // --- Resume Modal Handlers ---
  // Prevent multiple abort controllers
  const openResumeControllerRef = useRef(null);
  const toast = useToast();

  const handleOpenComment = () => {
    setShowCommentModal(true);
    setComment(savedComment || "");
  };
  const handleCloseComment = () => setShowCommentModal(false);
  const handleSaveComment = () => {
    setSavedComment(comment);
    setShowCommentModal(false);
  };
  
  const handleOpenResume = async (e) => {
    await fetchResumePreview(e);
    setShowResumeModal(true);
  };
  useEffect(() => {
    return () => {
      if (openResumeControllerRef.current) {
        openResumeControllerRef.current.abort();
      }
    };
  }, []);
  const handleCloseResume = () => {
    setShowResumeModal(false);
    setResumeUrl(null);
    setResumeError("");
    setResumeLoading(false);
    setResumeFileType(null);
  };

  

    const handleUpdateComment = (updatedData) => {
      candidate.comment_count = updatedData?.updatedCount
      onCandidateUpdateFilter?.(candidate);
  };

  // CV Modal show/hide/expand/collapse
  const handleOpenFormattedCVTypeModal = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setShowFormattedCVTypeModal(true);
  };

  const handleCloseFormattedCVTypeModal = () => {
    setShowFormattedCVTypeModal(false);
  };

  const handleShowCVModal = async (type, e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setFormattedCVType(type);
    setShowFormattedCVTypeModal(false);
    setExpanded(false);

    // fetch resume preview (if not already fetched) and then open CV modal
    fetchResumePreview().finally(() => {
      setShowCVModal(true);
      setValidationError(null);
    });

    // Fetch formatted CV
    setFormattedCVLoading(true);
    setFormattedCVError('');

    try {
      const response = await RecruiterApi.formattedCV({
        request_id: generateRequestId(),
        candidate_id: candidate.id.toString(),
        email: candidate.email,
        tenant: "GBB",
        template_path: "/app/cvtemplate/MPH_Confidential_template.docx",
        new_template_path: "/app/cvtemplate/MPH_Standard_template.docx",
        type,
      });

      if (response && response.success && response.data?.data) {
        setFormattedCVUrl(response.data.data);
      } else if (response && response.success && response.data?.cv_origin_link?.sas_token_url) {
        setFormattedCVUrl(response.data.cv_origin_link.sas_token_url);
      } else {
        setFormattedCVError('Failed to load formatted CV');
        setFormattedCVUrl(null);
      }
    } catch (error) {
      console.error('Error fetching formatted CV:', error);
      setFormattedCVError('Failed to load formatted CV');
      setFormattedCVUrl(null);
    } finally {
      setFormattedCVLoading(false);
    }
  };
  const handleCloseCVModal = () => {
    setShowCVModal(false);
    setExpanded(false);
  };

  const fetchResumePreview = async (stopPropagationEvent) => {
    if (stopPropagationEvent && stopPropagationEvent.stopPropagation)
      stopPropagationEvent.stopPropagation();
    setResumeError("");
    setResumeLoading(true);
    if (openResumeControllerRef.current) {
      openResumeControllerRef.current.abort();
    }
    const controller = new AbortController();
    openResumeControllerRef.current = controller;
    const signal = controller.signal;
    try {
      const response = await RecruiterApi.getResumePreview(
        {
          user_payload: {
            request_id: generateRequestId(),
          },
          candidate_id: candidate.id,
        },
        signal
      );
      if (response.success) {
        setResumeUrl(response.data.sas_token_url);
        setResumeFileType(response.data.filetype || null);
        setResumeError("");
      } else {
        setResumeFileType(null);
        setResumeUrl(null);
        setResumeError("Failed to load resume. Please try again.");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        setResumeFileType(null);
        setResumeError("Failed to load resume. Please try again.");
        setResumeUrl(null);
      }
    } finally {
      setResumeLoading(false);
    }
  };
  // --- Submit to AM logic ---

  const handleSubmitWithMandatoryFields = async () => {
    setValidationError(null);
    setSubmittingToAM(true);
    let newCandidateData = candidate;
    try {
      const requestBody = {
        candidate_id: candidate.id,
        user_payload: {
          request_id: generateRequestId(),
          email: candidate.email || "",
        },
      };
      const response = await resumeUpload.getCandidateDetailsRecruiter(requestBody);
      if (response && response.success && response.data) {
        newCandidateData = response.data;
        setResumeCandidateData(newCandidateData);
      } else {
        setResumeCandidateData(candidate);
      }
      if (showJobsModal) {
        setShowJobsModal(false)
        setSelectedJobForApplicant('')
      }
      setShowFillModal(true);
    } catch (err) {
      if (showJobsModal) {
        setShowJobsModal(false)
        setSelectedJobForApplicant('')
      }
      setValidationError(
        "Failed to fetch candidate's resume details. Please try again."
      );
    } finally {
      if (showJobsModal) {
        setShowJobsModal(false)
        setSelectedJobForApplicant('')
      }
      setSubmittingToAM(false);
    }
  };

  const handleCloseFillModal = (closedCandidateId) => {
    setShowFillModal(false);
    if (closedCandidateId && candidate.id === closedCandidateId) {
      if (typeof onSubmitCandidate === "function") {
        onSubmitCandidate(candidate.id);
      }
    }
  };

  const fetchCountryGuidOptions = async () => {
    try {
      setCountryGuidLoading(true);
      const res = await resumeUpload.getCountryGuid({
        user_payload: { request_id: generateRequestId() },
      });
      if (res?.success && Array.isArray(res.data)) {
        const normalizedCountries = res.data
          .map((item) => ({
            ...item,
            country_name: item?.country_name || item?.name || "",
            country_guid:
              item?.country_guid ||
              item?.guid ||
              item?.id ||
              item?.country_name ||
              item?.name ||
              "",
          }))
          .filter((item) => item.country_name);
        setCountryGuidOptions(normalizedCountries);
      } else {
        setCountryGuidOptions([]);
      }
    } catch (error) {
      setCountryGuidOptions([]);
    } finally {
      setCountryGuidLoading(false);
    }
  };

  const ensureResumeEditLovData = async () => {
    const tasks = [];
    if (!Array.isArray(countryGuidOptions) || countryGuidOptions.length === 0) {
      tasks.push(fetchCountryGuidOptions());
    }
    if (!sectors?.loaded && !sectors?.loading) {
      tasks.push(fetchSectors());
    }
    if (!languages?.loaded && !languages?.loading) {
      tasks.push(fetchLanguages());
    }
    if (tasks.length > 0) {
      await Promise.allSettled(tasks);
    }
  };

  const extractLanguageEntries = (langArray) => {
    if (!Array.isArray(langArray)) return [];
    return langArray
      .map((langObj) =>
        typeof langObj === "object"
          ? (langObj?.language ||
              langObj?.name ||
              langObj?.label ||
              langObj?.value ||
              langObj?.language_code)
          : langObj
      )
      .filter((lang) => lang != null && lang !== "");
  };

  const normalizeDateForInput = (value) => {
    if (!value) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return "";
    return parsedDate.toISOString().slice(0, 10);
  };

  const findCountryName = (countryNameOrGuid) => {
    if (!countryNameOrGuid) return "";
    const input = String(countryNameOrGuid).trim();
    const match = countryGuidOptions.find(
      (option) =>
        String(option.country_guid) === input ||
        String(option.country_name).toLowerCase() === input.toLowerCase() ||
        String(option?.name || "").toLowerCase() === input.toLowerCase()
    );
    return match?.country_name || match?.name || input;
  };

  useEffect(() => {
    if (!showResumeEditModal || !resumeEditCandidate || resumeEditFormInitialized) return;
    const selectedLanguageNames = extractLanguageEntries(resumeEditCandidate?.languages);
    const mappedLanguageValues = selectedLanguageNames
      .map((languageName) => {
        const match = (languages?.data || []).find(
          (option) =>
            String(option.label).toLowerCase() === String(languageName).toLowerCase() ||
            String(option.value).toLowerCase() === String(languageName).toLowerCase()
        );
        return match?.value || languageName;
      })
      .filter(Boolean);

    const sectorNames =
      Array.isArray(resumeEditCandidate?.sectors) && resumeEditCandidate.sectors.length > 0
        ? resumeEditCandidate.sectors
        : Array.isArray(resumeEditCandidate?.sector_name)
          ? resumeEditCandidate.sector_name
          : typeof resumeEditCandidate?.sector_name === "string"
            ? resumeEditCandidate.sector_name
                .split(",")
                .map((value) => value.trim())
                .filter(Boolean)
            : (resumeEditCandidate?.sector_name ? [resumeEditCandidate.sector_name] : []);

    const mappedSectorValues = sectorNames
      .map((sectorName) => {
        const match = (sectors?.data || []).find(
          (option) =>
            String(option.label).toLowerCase() === String(sectorName).toLowerCase() ||
            String(option.value).toLowerCase() === String(sectorName).toLowerCase()
        );
        return match?.value || sectorName;
      })
      .filter(Boolean);

    setResumeEditForm({
      phone: resumeEditCandidate?.phone || "",
      gender:
        (resumeEditCandidate?.gender || "").toLowerCase() === "none"
          ? ""
          : (resumeEditCandidate?.gender || "").toLowerCase(),
      location: findCountryName(resumeEditCandidate?.location || resumeEditCandidate?.city || ""),
      nationality: findCountryName(resumeEditCandidate?.nationality || ""),
      languages: mappedLanguageValues,
      sectors: mappedSectorValues,
      date_of_birth: normalizeDateForInput(resumeEditCandidate?.date_of_birth),
    });
    setResumeEditFormInitialized(true);
  }, [showResumeEditModal, resumeEditCandidate, languages?.data, sectors?.data, countryGuidOptions, resumeEditFormInitialized]);

  const handleResumeEditFieldChange = (field, value) => {
    if (resumeEditSaving) return;
    if (field === "sectors") {
      const nextSectors = Array.isArray(value) ? value.filter(Boolean) : [];
      if (nextSectors.length > 0 && resumeEditError === SECTOR_REQUIRED_ERROR) {
        setResumeEditError("");
      }
      setResumeEditForm((prev) => ({ ...prev, sectors: nextSectors }));
      return;
    }
    if (field === "phone") {
      const numbersOnly = value.replace(/\D/g, "").slice(0, 15);
      setResumeEditForm((prev) => ({ ...prev, phone: numbersOnly }));
      return;
    }
    if (field === "location" || field === "nationality") {
      const match = countryGuidOptions.find(
        (option) => String(option.country_guid) === String(value)
      );
      const resolvedValue = match?.country_name || value;
      setResumeEditForm((prev) => ({ ...prev, [field]: resolvedValue }));
      return;
    }
    setResumeEditForm((prev) => ({ ...prev, [field]: value }));
  };

  const getCountryNameFromGuid = (guidOrName) => (guidOrName ? String(guidOrName).trim() : "");

  const handleOpenResumeEdit = async (e) => {
    e.stopPropagation();
    setShowResumeEditModal(true);
    setResumeEditLoading(true);
    setResumeEditError("");
    setResumeEditFormInitialized(false);
    try {
      await ensureResumeEditLovData();
      const candidateResponse = await resumeUpload.getCandidateDetailsRecruiter({
        candidate_id: candidate.id,
        user_payload: {
          request_id: generateRequestId(),
          email: user?.email || candidate?.email || "",
        },
      });
      if (candidateResponse?.success && candidateResponse?.data) {
        setResumeEditCandidate(candidateResponse.data);
      } else {
        setResumeEditError("Unable to fetch extracted details.");
      }
    } catch (error) {
      setResumeEditError("Unable to fetch extracted details.");
    } finally {
      setResumeEditLoading(false);
    }
  };

  const handleResumeEditClose = () => {
    if (resumeEditSaving) return;
    setShowResumeEditModal(false);
    setResumeEditCandidate(null);
    setResumeEditLoading(false);
    setResumeEditError("");
    setResumeEditSaving(false);
    setResumeEditFormInitialized(false);
    setResumeEditForm({
      phone: "",
      gender: "",
      location: "",
      nationality: "",
      languages: [],
      sectors: [],
      date_of_birth: "",
    });
  };

  const handleResumeEditSave = async () => {
    if (resumeEditSaving) return;
    if (!resumeEditCandidate?.id) return;
    setResumeEditSaving(true);
    setResumeEditError("");
    try {
      if (
        resumeEditForm.date_of_birth &&
        /^\d{4}-\d{2}-\d{2}$/.test(resumeEditForm.date_of_birth) &&
        resumeEditForm.date_of_birth > todayDateForInput
      ) {
        setResumeEditError("Date of birth cannot be a future date.");
        return;
      }

      const selectedLanguagesPayload = (resumeEditForm.languages || [])
        .map((value) => {
          const match = (languages?.data || []).find(
            (option) => String(option.value) === String(value)
          );
          const languageCode = String(
            match?.language_code || match?.code || match?.value || value || ""
          ).trim();
          if (!languageCode) return null;
          return { language_code: languageCode, level_code: "3" };
        })
        .filter(Boolean);

      const selectedSectorValues = (resumeEditForm.sectors || []).filter(Boolean);
      const selectedSectorLabels = selectedSectorValues
        .map((value) => {
          const match = (sectors?.data || []).find(
            (option) => String(option.value) === String(value)
          );
          return match?.label || value;
        })
        .filter(Boolean);

      if (selectedSectorLabels.length === 0) {
        setResumeEditError(SECTOR_REQUIRED_ERROR);
        return;
      }

      const editedFields = [
        "phone",
        "gender",
        "location",
        "nationality",
        "date_of_birth",
        "languages",
        "sectors",
      ];

      const allModifications = {
        phone: resumeEditForm.phone || "",
        gender: resumeEditForm.gender || "",
        location: resumeEditForm.location || "",
        nationality: resumeEditForm.nationality || "",
        date_of_birth: resumeEditForm.date_of_birth || null,
        languages: selectedLanguagesPayload,
        sectors: selectedSectorLabels,
      };

      const resumeModifications = editedFields.reduce((acc, key) => {
        acc[key] = allModifications[key];
        return acc;
      }, {});

      const saveRes = await resumeUpload.saveCandidateModifications({
        candidate_id: resumeEditCandidate.id,
        resume_modifications: resumeModifications,
        edited_fields: editedFields,
        user_payload: {
          request_id: generateRequestId(),
          email: user?.email || resumeEditCandidate?.email || candidate?.email || "",
          user_id: Number(user?.id),
        },
      });

      if (!saveRes?.success) {
        setResumeEditError(saveRes?.message || "Failed to save candidate details.");
        return;
      }

      toast.success(saveRes?.message || "Candidate details updated successfully.");
      onCandidateUpdateFilter?.({
        ...candidate,
        phone: resumeEditForm.phone || "",
        gender: resumeEditForm.gender || "",
        location: getCountryNameFromGuid(resumeEditForm.location),
        city: getCountryNameFromGuid(resumeEditForm.location),
        nationality: getCountryNameFromGuid(resumeEditForm.nationality),
        sectors: selectedSectorLabels,
        date_of_birth: resumeEditForm.date_of_birth || "",
        languages: selectedLanguagesPayload,
      });
      handleResumeEditClose();
      onMoveToUploadedTab?.();
    } catch (error) {
      setResumeEditError("Failed to save candidate details.");
    } finally {
      setResumeEditSaving(false);
    }
  };

  const handleConfirmSubmitToAM = () => {
    if (!isMatchingPage) {
      if (isAllJobsLoading) return
      setIsAllJobsLoading(true)
      fetchAllJobs()
    } else {
      setMphJobId(mph_jobid)
      handleSubmitWithMandatoryFields()
    }
  };

  const fetchAllJobs = async () => {
    try {
      let payload = {
        user_payload: {
          request_id: generateRequestId(),
          email: candidate.email,
          user_id: candidate.id,
          tenant: "ABC"
        }
      }
      let response = await resumeUpload.fetchAlljobsDropdown(payload)
      setIsAllJobsLoading(false)
      if (response.success) {
        setShowJobsModal(true);
        setCurrentJobs(response.data);
      }
    } catch (error) {
      setIsAllJobsLoading(false)
      console.log(error)
    }
  }

  const navigate = useNavigate();
  const handleCardClick = (e) => {
    if (
      e.target.closest("button") ||
      e.target.closest("input") ||
      e.target.closest("select") ||
      e.target.closest("textarea") ||
      e.target.closest(".resume-edit-modal") ||
      e.target.closest(".comment-modal") ||
      e.target.closest(".resume-modal") ||
      e.target.closest(".cv-modal")
    ) {
      return;
    }
    if (isMatchingPage) {
      if (typeof onMatchingCandidateClick === "function") {
        onMatchingCandidateClick(candidate);
      }
      return;
    }
    if (candidate.id) {
      const search = query
        ? `?query=${encodeURIComponent(query)}&type=${searchType}`
        : "";
      navigate(`/candidates/${candidate.id}${search}`);
    }
  };

  // Email Modal handlers -- Fix: use correct candidate email/name fields
  const handleOpenEmail = (e) => {
    e.stopPropagation();
    setShowEmailModal(true);
    setEmailSent(false);
    setEmailError("");
  };
  const handleCloseEmail = () => {
    setShowEmailModal(false);
    setEmailSent(false);
    setEmailError("");
  };
  const handleSendEmail = async (body) => {
    setSendingEmail(true);
    setEmailError('');
    try {
      const response = await RecruiterApi.sendMail(body)
      console.log(response);

      if (response.success) {
        if (response.data) {
          candidate.is_email_sent = true;
          candidate.email_sent_at = response?.data.email_sent_at || null;

          setCandidateData((prev) => ({
            ...prev,
            is_email_sent: true,
            email_sent_at: response?.data.email_sent_at || null,
          }));
          if (onUpdateCandidate) {
            onUpdateCandidate(candidate);
          }
          onCandidateUpdateFilter?.(candidate);
          toast.success(response.message || 'Email sent successfully');
        }
      } else {
        toast.warning(response.message || 'Failed to send email. Please try again.');
      }
      setEmailSent(true);
    } catch (err) {
      setEmailError('Failed to send email. Please try again.');
    } finally {
      setShowEmailModal(false);
      setSendingEmail(false);
    }
  };

  const handleSendSearchEmail = async (body) => {
    setSendingEmail(true);
    setEmailError('');
    try {
       let payload = {
            candidate_ids:[body.candidate_id],
            subject:body.subject,
            email_body: body.email_body,
            sender_email:user.email // can be dynamic based on logged in user
        }
      const response = await RecruiterApi.sendSearchMail(payload)
      console.log(response);

      if (response.success) {
        if (response.data) {
           const sentAt = response?.data?.email_sent_at || null;
           candidate.is_email_sent = true;
           candidate.email_sent_at = sentAt
           onCandidateUpdateFilter?.(candidate);
          toast.success(response.message || 'Email sent successfully');
        }
      } else {
        toast.warning(response.message || 'Failed to send email. Please try again.');
      }
      setEmailSent(true);
    } catch (err) {
      setEmailError('Failed to send email. Please try again.');
    } finally {
      setShowEmailModal(false);
      setSendingEmail(false);
    }
  };

  const toTitleCase = (str) => {
  try {
    if (!str) return '';
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  } catch (error) {
    console.error('toTitleCase error:', error);
    return '';
  }
};

  // Check if phone is a valid mobile number (enable if it has at least 2 digits)
  const isValidMobileNumber = () => {
    if (!candidate?.phone) return false;
    const phoneStr = String(candidate?.phone).trim();
    // Extract only digits and check if there are at least 2
    const digits = phoneStr.replace(/\D/g, '');
    return digits.length >= 2;
  };

 
  const sendWhatsappMsg = async (jobValueFromTemplate, selectedJobFromModal = null) => {
  try {
    setSendingWhatsApp(true);
    const selectedJobValue = jobValueFromTemplate?.trim() || jobDetails?.title || "job";
    const resolvedMphJobid = selectedJobFromModal?.mph_jobid || jobDetails?.mph_jobid || null;
    const resolvedJobId = selectedJobFromModal?.id || job_id || jobDetails?.id || null;
    let requestBody = {
      phone: candidate?.phone, // hardcoded for testing and need to change it to candidate.phone_number
	      template_payload: [
	        { "parameter_name": "candidate", "text": candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}`},
	        { "parameter_name": "recruiter", "text": user?.displayName || "the recruiter" },
	        { "parameter_name": "job", "text": selectedJobValue }
	      ],
	      template_name: "candidate_notification",
	      body_params: [
	        { "parameter_name": "candidate", "text": candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}` },
	        { "parameter_name": "recruiter", "text": user?.displayName || "the recruiter" },
	        { "parameter_name": "job", "text": selectedJobValue }
	      ],
      button_payloads: null,
      mph_jobid: resolvedMphJobid,
      job_id: resolvedJobId,
      candidate_id: candidate?.id || candidate?.candidate_id,
      user_payload: {
        request_id: generateRequestId()
      }
    };

	    console.log("WhatsApp request body candidate.id:", candidate?.id);
	    const response = await RecruiterApi.sendWhatsappMsg?.(requestBody);
	     if (response && response.success) {
	      toast.success('WhatsApp message sent successfully');
      const newNotification = {
        message_status: "sent",
        is_responded: false,
        sent_at: new Date().toISOString(),
        response: null,
        mph_jobid: resolvedMphJobid,
        job_id: resolvedJobId,
        job_title: selectedJobValue,
      };
	      const updatedCandidate = {
	        ...(candidate || {}),
	        whatsapp_notifications: [newNotification, ...((candidate?.whatsapp_notifications || []))],
	        whatsapp_has_pending: true,
	      };
	      onCandidateUpdateFilter?.(updatedCandidate);
	      setCandidateData((prev) => {
	        const base = prev || candidate || {};
	        return {
	          ...base,
	          whatsapp_notifications: [newNotification, ...((base.whatsapp_notifications || []))],
	        whatsapp_has_pending: true,
	        };
	      });
	    }  else {
	      toast.warning('Failed to send WhatsApp message. please try again later');
	    }
  } catch (error) {
    console.log(error);
  } finally {
    setSendingWhatsApp(false);
    setShowWhatsAppModal(false);
  }
	};
	const getWhatsAppTemplateMessage = () => {
	  const candidateFullName =  candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}`
	  return `Hi ${candidateFullName},
	
	This is ${user?.displayName || "recruiter"} from MPH. We have an exciting opportunity for ${jobDetails?.title|| "Job - JOXXXXXX"} that aligns with your experience. 
Would you like to receive a call from us to discuss more about this opportunity?.
Best regards,
MPH Team`;
};

  const handleBookmarkClick = async (e) => {
    e.stopPropagation();
    if (bookmarkLoading) return;
    setBookmarkLoading(true);

    try {
      let requestBody = {
        payload: {
          candidate_id: candidate.id,
          job_id: job_id,
          is_tagged: !isBookmarked,
        },
        user_payload: {
          request_id: generateRequestId()
        }
      }
      const response = await RecruiterApi.bookmarkCandidate?.(requestBody);
      if (response && response.success) {
        setIsBookmarked((prev) => !prev);
        if (typeof onTagAction === "function") {
          onTagAction(candidate.id, isBookmarked);
        }
      } else {
        toast.warning('Failed to tag. please try again later');
      }
    } catch (error) {
      toast.warning('Failed to tag. please try again later');
    } finally {
      setBookmarkLoading(false);
    }
  };


  const handleDownloadFormattedResumeClick = async () => {
    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "download",
        type: formattedCVType,
      };

      const response = await RecruiterApi.getFormattedResumePreview?.(requestBody);
      console.log("Download response:", response);

      const sasUrl = response?.data?.data?.sas_token_url?.trim();
      if (sasUrl) {
        const downloadUrl = sasUrl.replace(/ /g, "%20");

        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        toast.success("Download started...");
      } else {
        toast.warning("Failed to download resume else. Please try again later.");
      }
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.warning("Failed to download resumeeee. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };


  const handleViewFormattedResumeClick = async () => {

    try {
      console.log('reached view formatted');
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "view",
        type: formattedCVType,
      };

      const response = await RecruiterApi.getFormattedResumePreview?.(requestBody);
      console.log("View response:", response);

      if (response && response.data.status && response.data?.data?.sas_token_url) {
        let viewUrl = response?.data?.data?.sas_token_url.trim();

        viewUrl = viewUrl.replace(/ /g, "%20");

        const fileUrl = viewUrl.toLowerCase().endsWith(".docx")
          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            viewUrl
          )}`
          : viewUrl;

        console.log("Opening resume:", fileUrl);
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to open resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error opening resume:", error);
      console.log('this is error', error)
      toast.warning("Failed to open in exception resume. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };

  const handleViewResumeClick = async () => {
    console.log("Reached view");

    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "view",
      };

      const response = await RecruiterApi.getResumePreview?.(requestBody);
      console.log("View response:", response);

      if (response && response?.success && response?.data?.sas_token_url) {
        let viewUrl = response?.data?.sas_token_url.trim();

        viewUrl = viewUrl.replace(/ /g, "%20");

        const fileUrl = viewUrl.toLowerCase().endsWith(".docx")
          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            viewUrl
          )}`
          : viewUrl;

        console.log("Opening resume:", fileUrl);
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to open resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error opening resume:", error);
      console.log('this is error', error)
      toast.warning("Failed to open in exception resume. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };

const formatPercentage = (value) => {
  return value !== undefined && value !== null && !isNaN(value)
    ? `${Number(value).toFixed(1)}%`
    : "0%";
};
  const handleDownloadResumeClick = async () => {
    console.log("Reached download");

    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "download",
      };

      const response = await RecruiterApi.getResumePreview?.(requestBody);
      console.log("Download response:", response);

      if (response && response.success && response.data?.sas_token_url) {
        let downloadUrl = response.data.sas_token_url.trim();

        downloadUrl = downloadUrl.replace(/ /g, "%20");

        console.log("Opening download link:", downloadUrl);

        window.open(downloadUrl, "_blank", "noopener,noreferrer");

        toast.success("Download started...");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to download resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.warning("Failed to download resume. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };

  const roundedLlmScore =
    typeof candidate.llm_score === "number"
      ? Number(candidate.llm_score).toFixed(2)
      : candidate.llm_score;
  const normalizedResumeStatus = String(candidate?.resume_status || "").trim().toUpperCase();
  const isResumeUnderReview =
    normalizedResumeStatus === "UNDER REVIEW" || normalizedResumeStatus === "UNDER REVIEW" || normalizedResumeStatus === "VALIDATION_FAILED" || normalizedResumeStatus === "VALIDATION_FAILED";

  // Main render
  return (
    <div
      className={`text-left p-5 rounded-2xl flex flex-col gap-4 cursor-pointer transition-shadow shadow-lg border border-gray-100 anim-slideUp ${
        isSelected ? "ring-2 ring-emerald-300 bg-emerald-50" : "bg-white"
      }`}
      onClick={handleCardClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{ position: "relative" }}
    >
      {/* Selection checkbox: shown on hover or when selection mode is active (selectedIds.length > 0) */}
      {(() => {
        // Show checkbox only on non-matching pages and when hovering or in selection mode
        const showCheckbox =
          !isMatchingPage &&
          (isHovering ||
            (Array.isArray(selectedIds) && selectedIds.length > 0) ||
            isSelected);
        if (!showCheckbox) return null;
        return (
          <div className="absolute" style={{ top: 8, right: 10, zIndex: 40 }}>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                const newSelected = !isSelected;
                // Notify parent: pass candidate id, selected boolean, and emailType 'generic' for bulk actions
                try {
                  const selectedCandidateMeta = candidateData || candidate || {};
                  onSelectionChange(
                    candidate.id,
                    candidate.email,
                    newSelected,
                    selectedCandidateMeta?.generic_email_sent_at ??
                    selectedCandidateMeta?.email_sent_at ??
                    null,
                    selectedCandidateMeta?.generic_email_sent_by ??
                    selectedCandidateMeta?.email_sent_by ??
                    null,
                    selectedCandidateMeta?.generic_email_sent_by_first_name ??
                    selectedCandidateMeta?.email_sent_by_first_name ??
                    null,
                    selectedCandidateMeta?.generic_email_sent_by_last_name ??
                    selectedCandidateMeta?.email_sent_by_last_name ??
                    null,
                    selectedCandidateMeta?.generic_email_sent_by_email ??
                    selectedCandidateMeta?.email_sent_by_email ??
                    null
                  );
                } catch (err) {
                  // swallow
                }
              }}
              aria-pressed={isSelected}
              aria-label={
                isSelected ? "Deselect candidate" : "Select candidate"
              }
              className={`flex items-center justify-center w-6 h-6 rounded-full transition-colors duration-150 focus:outline-none ${
                isSelected
                  ? "bg-emerald-600 shadow-lg"
                  : "bg-white border border-gray-200 hover:bg-gray-50"
              }`}
              title={isSelected ? "Deselect" : "Select"}
            >
              {/* Check icon (SVG) */}
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  stroke={isSelected ? "transparent" : "#E5E7EB"}
                  strokeWidth="0"
                  fill={isSelected ? "transparent" : "transparent"}
                />
                <path
                  d="M20 6L9 17l-5-5"
                  stroke={isSelected ? "#fff" : "#9CA3AF"}
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </button>
          </div>
        );
      })()}

      <div className="flex items-center gap-4">
        {/* Custom Ring Avatar Head */}
        <div className="relative" style={{ width: 48, height: 48 }}>
          {/* Outer ring */}
          <div
            className="absolute rounded-full"
            style={{
              width: "50px",
              height: "50px",
              left: "0px",
              top: "0px",
              background:
                candidate?.status === "Incomplete"
                  ? "linear-gradient(208.83deg, #F3F4F6 47.57%, #DA819E 59.11%, #CD4772 65.72%, #C72A5C 71.92%, #C41C51 77.93%, #C10D46 85.09%)"
                  : "#F3F4F6",
            }}
          />
          {/* Inner circle, show avatar or initials */}
          <div
            className="absolute rounded-full flex items-center justify-center"
            style={{
              width: "36px",
              height: "36px",
              left: "7px",
              top: "7px",
              background: "#F3F4F6",
              overflow: "hidden",
            }}
          >
            {candidate.avatar ? (
              <img
                src={candidate.avatar}
                alt={ candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
                className="w-12 h-12 rounded-full object-cover"
                style={{ width: 48, height: 48 }}
              />
            ) : (
              <span
                style={{
                  fontFamily: "Raleway, sans-serif",
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: "#246B6A",
                }}
              >
                {getInitials(candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`)}
              </span>
            )}
          </div>
          {/* INCOMPLETE badge - positioned on the ring */}
          {candidate?.status === "Incomplete" && (
            <div
              className="absolute flex items-center  hidden justify-center"
              style={{
                width: "44px",
                height: "20px",
                left: "2px",
                top: "26px",
                transform: "rotate(7.47deg)",
              }}
            >
              <div
                className="absolute flex items-center justify-center"
                style={{
                  width: "auto",
                  height: "16px",
                  left: "0px",
                  top: "0px",
                  background: "#C10D46",
                  borderRadius: "8px",
                  padding: "2px 8px",
                  transform: "rotate(-7.47deg)",
                }}
              >
                <span
                  style={{
                    fontFamily: "Raleway, sans-serif",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "8px",
                    lineHeight: "10px",
                    color: "#FFFFFF",
                    letterSpacing: "0.3px",
                    textTransform: "uppercase",
                  }}
                >
                  INCOMPLETE
                </span>
              </div>
            </div>
          )}
          {isResumeUnderReview && (
            <div
              className="absolute flex items-center  hidden justify-center"
              style={{
                width: "44px",
                height: "20px",
                left: "2px",
                top: "26px",
                transform: "rotate(7.47deg)",
              }}
            >
              <div
                className="absolute flex items-center justify-center"
                style={{
                  width: "auto",
                  height: "16px",
                  left: "0px",
                  top: "0px",
                  background: "#C10D46",
                  borderRadius: "8px",
                  padding: "2px 8px",
                  transform: "rotate(-7.47deg)",
                }}
              >
                <span
                  style={{
                    fontFamily: "Raleway, sans-serif",
                    fontStyle: "normal",
                    fontWeight: 700,
                    fontSize: "8px",
                    lineHeight: "10px",
                    color: "#FFFFFF",
                    letterSpacing: "0.3px",
                    textTransform: "uppercase",
                  }}
                  title="Please review "
                >
                  UNDER REVIEW
                </span>
              </div>
            </div>
          )}
          {/* Broadbean icon */}
              {candidate?.cv_origin ==='Broadbean' && (
                    <img
                      src={require("../../../assets/BB-Logo.svg").default}
                      alt="Broadbean"
                      className="absolute bottom-0 -right-2 w-5 h-5 rounded-full border-2 border-white bg-white shadow"
                      title="Imported from Broadbean"
                    />
                  )}
        </div>

        <div className="flex-1 min-w-0">
        <div className="font-semibold text-gray-333 truncate flex items-center gap-1">
           {candidate.full_name ?? `${candidate.first_name} ${candidate.last_name}`} – (
          {candidate.years_of_experience} years)
            {/* Warning icon for incomplete status */}
            {candidate?.crm_status === "Incomplete" ? (
              // Alert badge (mimics list experience)
              <span
                className="ml-2 relative flex items-center"
                tabIndex={0}
                style={{ outline: "none" }}
                aria-label="Profile incomplete"
                onMouseEnter={() => setShowWarningTooltip(true)}
                onMouseLeave={() => setShowWarningTooltip(false)}
                onFocus={() => setShowWarningTooltip(true)}
                onBlur={() => setShowWarningTooltip(false)}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    position: "relative",
                    height: 28,
                    width: 28,
                  }}
                >
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: "50%",
                      background: "#FFF1F3",
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <FiAlertTriangle
                      size={15}
                      style={{
                        position: "absolute",
                        top: 5,
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "#C10D46",
                        background: "transparent",
                        verticalAlign: "top",
                      }}
                    />
                  </div>
                </div>
              </span>
            ) : candidate.crm_status == "Shortlisted" ? (
              <span className="px-2 py-1 rounded-full text-[0.6rem] font-semibold bg-blue-100 text-blue-700 shadow-sm">
                Shortlisted
              </span>
            ) : candidate.crm_status == "Interviewing" ? (
              <span className="px-2 py-1 rounded-full text-[0.6rem] font-semibold bg-orange-100 text-orange-700 shadow-sm">
                Interviewing
              </span>
            ) : (
              <SkillBadge key="active">
                {candidate.crm_status ? candidate.crm_status : "Active"}
              </SkillBadge>
            )}
                          {candidate.status&&(
                            <div className="absolute font-semibold px-2 py-1" style={{
               background: 'white',
color: '#006400',
borderRadius: '99px',
boxShadow: '0 0 10px #ababab4b',
fontSize: '11px',
top: '-10px',
left: '13px'
              }}>
                {candidate.status}
              </div>
                          )}
            {isMatchingPage && candidate?.crmStatus && (
              <span className="mph-light mph-primary text-[10px] font-semibold px-2 py-0.5 rounded-full border shadow">
                {candidate.crmStatus}
              </span>
            )}
          </div>
          <p className="text-xs text-gray-999 mt-1 truncate">
            {candidate.highest_position}
          </p>
        </div>
        {(candidate?.resume_status ==='UNDER REVIEW'  || candidate?.resume_status === 'VALIDATION_FAILED' )&& (
          <div className="flex items-center gap-2">
            <span
              className={`px-2 py-1 rounded-full text-[10px] font-semibold border ${
                isResumeUnderReview
                  ? "bg-amber-100 text-amber-700 border-amber-200"
                  : "bg-gray-100 text-gray-700 border-gray-200"
              }`}
            >
             UNDER REVIEW
            </span>
            {isResumeUnderReview && (
            <button
                type="button"
                onClick={handleOpenResumeEdit}
                title="Edit"
                className="p-1.5 rounded-full text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700 transition-colors duration-150"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3.5 h-3.5 text-gray-500"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </button>
            )}
          </div>
        )}

        {isMatchingPage && (
          // <div className="relative group text-center min-w-[54px] overflow-visible">
          //   <p className="text-xl font-bold profiler">{roundedLlmScore}%</p>
          //   <p className="text-xs font-semibold profiler">Match</p>
          //   <span
          //       className="pointer-events-none absolute top-full mt-2
          //                 opacity-0 translate-y-1
          //                 group-hover:opacity-100 group-hover:translate-y-0
          //                 transition-all duration-200 ease-out
          //                 max-w-sm min-w-[280px]
          //                 rounded-md bg-gray-900 px-4 py-2
          //                 text-xs leading-relaxed text-white shadow-lg
          //                 whitespace-normal break-words">
          //       <span className="...">
          //         <span className="font-semibold">Match Score: {roundedLlmScore}%</span>
          //         <br />
          //         This score indicates how well the candidate's profile aligns with the job requirements 
          //         based on skills, experience, and qualifications.
          //       </span>
          //     </span>
          // </div>
            <div className="relative text-center min-w-[54px] group match-tooltip-text">
              <div className="group cursor-pointer">
                
                {/* Tooltip below */}
                <SmartTooltip content={
  <>
    <span>Title : {Number(candidate?.score_breakdown?.title)?.toFixed(1)}%</span><br />
    <span>Experience : {Number(candidate?.score_breakdown?.experience)?.toFixed(1)}%</span><br />
    <span>Education : {Number(candidate?.score_breakdown?.education)?.toFixed(1)}%</span><br />
    <span>Responsibility & Skills : {Number(candidate?.score_breakdown?.responsibility)?.toFixed(1)}%</span>
  </>
}>
  {/* your trigger element, e.g. the score badge */}
  <p className="text-xl font-bold profiler">{roundedLlmScore}%</p>
  <p className="text-xs font-semibold profiler">Match</p>
</SmartTooltip>
              </div>
            </div>
        )}
        {isMatchingPage && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              setCollapsed(!collapsed);
            }}
            className="text-xs text-gray-600 border rounded-full px-1 py-1 hover:bg-gray-100"
          >
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{
                transform: collapsed ? "rotate(270deg)" : "rotate(90deg)",
                transition: "transform 0.3s",
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        )}
      </div>

      {showWarningTooltip && (
        <div
          className="absolute right-5 z-[9999] flex items-start gap-2 rounded-md px-3 py-2 text-xs font-normal shadow-lg transition-opacity duration-200"
          style={{
            backgroundColor: "rgb(255, 241, 243)",
            color: "rgb(193, 13, 70)",
            top: "11%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            width: "max-content",
            maxWidth: 359,
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.5,
            overflow: "visible", // ✅ makes sure it's not clipped
          }}
        >
          {/* Tooltip Arrow */}
          <div
            className="absolute"
            style={{
              left: "-10px",
              top: "50%",
              transform: "translateY(-50%)",
              width: 0,
              height: 0,
              borderTop: "6px solid transparent",
              borderBottom: "6px solid transparent",
              borderRight: "10px solid #FFF1F3",
            }}
          />

          {/* Tooltip Text */}
          <span className="block text-[#C10D46] leading-snug">
            The profile is missing mandatory details such as nationality, phone
            number, and experience. Please upload a resume containing these
            details to proceed with shortlisting.
          </span>
        </div>
      )}
      {!collapsed && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-xs w-full">
            <div className="min-w-0">
              <p className="text-xs text-gray-999">Email</p>
              <p
                className="font-semibold text-gray-800 break-all truncate max-w-full"
                style={{ wordBreak: "break-all" }}
                title={candidate.email}
              >
                {candidate.email || "-"}
              </p>
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-999">Contact number</p>
              <p
                className="font-semibold text-gray-800 truncate max-w-full"
                style={{ wordBreak: "break-all" }}
                title={candidate.phone}
              >
                {candidate.phone || "-"}
              </p>
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-999">Gender</p>
              <p className="font-semibold text-gray-800 truncate max-w-full">
                { candidate.gender ? candidate.gender === 'None' ? "-" : candidate.gender : "-"}
              </p>
            </div>
            <div className="min-w-0">
              <p className="text-xs text-gray-999">Location</p>
              <p className="font-semibold text-gray-800 truncate max-w-full">
                {candidate.location || "-"}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4 text-xs">
            <div>
              <p className="text-xs text-gray-999">Nationality</p>
              <p className="font-semibold text-gray-800">
                {candidate.nationality_disclosed ? (
                  <span className="italic text-xs text-gray-500">
                    Not disclosed
                  </span>
                ) : candidate.nationality ? (
                  candidate.nationality
                ) : (
                  "-"
                )}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-999">Languages known</p>
              <p className="font-semibold text-gray-800 uppercase">
               
    {(() => {
                  const extractLanguages = (langArray) => {
                  if (langArray == null) return [];
    
    // If it's a string, try to parse it as JSON
    if (typeof langArray === 'string') {
      // If empty string, return empty array
      if (langArray.trim() === '') return [];
      
      try {
        const parsed = JSON.parse(langArray);
        // If parsed result is an array, use it
        if (Array.isArray(parsed)) {
          langArray = parsed;
        } else {
          // If it's a single string value after parsing, return it
          return [langArray];
        }
      } catch (e) {
        try {
          //handleing different types of format array
            const isArray = JSON.parse(langArray.replace(/'/g, '"'));
             if(Array.isArray(isArray) && isArray?.length>0) return isArray
        } catch (error) {
          return []
        }
        // If JSON parse fails, treat it as a plain string
        return [langArray];
      }
    }
    
    // If it's not an array at this point, return empty
    if (!Array.isArray(langArray)) return [];
    
    // Process array elements
    return langArray
      .map((langObj) => typeof langObj === "object" ? langObj?.language : langObj)
      .filter((lang) => lang != null && lang !== "");
  }
    const allLangs = [
    ...extractLanguages(candidate.languages),
    ...extractLanguages(candidate.other_languages),
  ];
  
  return allLangs.length > 0 ? allLangs.join(", ") : "-";
                })()}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-999">Sector</p>
              <p className="font-semibold text-gray-800">
                       {Array.isArray(candidate?.sector_name) 
  ? candidate.sector_name.join(", ") 
  : candidate?.sector_name || "-"}
              </p>
            {/* <p className="text-xs font-semibold text-gray-700 mt-1 break-words">
              {candidate?.sectors?.length
                ? candidate.sectors.join(", ")
                : "-"}
            </p> */}
            </div>
            <div>
              <p className="text-xs text-gray-999">CV origin</p>
              <p className="font-semibold text-gray-800">
                {candidate.cv_origin && candidate.hub_source_id
                  ? `${candidate.cv_origin} (${candidate.hub_source_id})`
                  : candidate.cv_origin
                  ? candidate.cv_origin
                  : candidate.hub_source_id
                  ? `(${candidate.hub_source_id})`
                  : "-"
                }
              </p>
            </div>
          </div>

          {/* <div>
            <p className="text-xs text-gray-999">Skills & Expertise</p>
            <div className="flex flex-wrap gap-2 mt-2 items-center">
              {visibleSkills.map((skill, index) => (
                <SkillBadge key={`${skill}-${index}`}>{skill}</SkillBadge>
              ))}

              {hiddenCount > 0 && !showAllSkills && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllSkills(true);
                  }}
                  className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
                >
                  +{hiddenCount} more
                </button>
              )}

              {showAllSkills && hiddenCount > 0 && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowAllSkills(false);
                  }}
                  className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
                >
                  Show less
                </button>
              )}
            </div>
          </div> */}
         
          <div className="flex items-center  border-t border-gray-100 pt-2 mt-2">
            <div className="flex items-center gap-2">
              <button
                className={iconButtonStyles}
                onClick={handleOpenResume}
                title="Preview Resume"
                type="button"
                disabled={submittingToAM}
              >
                {/* <FiPaperclip className="mph-primary" size={16} /> */}
              <FileText size={18} className='mph-primary' />
              </button>
              {isMatchingPage && (
                <button
                  className={iconButtonStyles}
                  onClick={(e) => {
                    setEmailType("default");
                    handleOpenEmail(e);
                  }}
                  title={
                    candidate?.generic_email_sent_at || candidate?.email_sent_at
                      ? `Last email sent on ${new Date(
                          candidate?.generic_email_sent_at ?? candidate?.email_sent_at
                        ).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
                      : "Send Email"
                  }
                  type="button"
                  disabled={submittingToAM}
                >
                  <FiMail className="mph-primary" size={16} />
                </button>
              )}

              {!isMatchingPage && (
                <button
                  className={iconButtonStyles}
                  onClick={(e) => {
                    setEmailType("generic");
                    handleOpenEmail(e);
                  }}
                  title={
                    candidate?.generic_email_sent_at || candidate?.email_sent_at
                      ? `Last email sent on ${new Date(
                          candidate?.generic_email_sent_at ?? candidate?.email_sent_at
                        ).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
                      : "Send Email"
                  }
                  type="button"
                  disabled={submittingToAM}
                >
                  <FiMail className="mph-primary" size={16} />
                </button>
              )}
	              <button
	                className={`${iconButtonStyles} text-green-500 hover:text-green-600 relative ${
	                  !isValidMobileNumber() ? "opacity-50 cursor-not-allowed" : ""
	                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  if (isValidMobileNumber()) {
                    setShowWhatsAppModal(true);
                  }
                }}
                disabled={!isValidMobileNumber()}
	                title={
	                  !isValidMobileNumber()
	                    ? "The candidate has not provided a mobile number."
	                    : (() => {
	                        const notifications = candidateData?.whatsapp_notifications;
	                        if (!notifications?.length) return "Send WhatsApp Message";
	                        const latest = notifications[0];
	                        const latestDate = latest?.sent_at ? `Last message sent on ${formatDate(latest.sent_at)}` : "";
	                        return latestDate || "Send WhatsApp Message";
	                      })()
	                }
	              >
	                <FaWhatsapp size={18} />
	                {(() => {
	                  const notifications = candidateData?.whatsapp_notifications;
	                  if (!Array.isArray(notifications) || notifications.length === 0) return null;

	                  const mphJobIds = notifications.map((n) => n?.mph_jobid).filter(Boolean);
	                  const threadCount = mphJobIds.length > 0 ? new Set(mphJobIds).size : notifications.length;
	                  if (threadCount <= 0) return null;

	                  const badgeText = threadCount > 99 ? "99+" : String(threadCount);
	                  return (
	                    <span className="absolute -top-2 -right-2 bg-emerald-600 text-white text-[10px] rounded-full h-5 min-w-5 px-1 flex items-center justify-center font-semibold border-2 border-white">
	                      {badgeText}
	                    </span>
	                  );
	                })()}
	              </button>
              <div className="relative inline-block">
                <button
                  className={`${iconButtonStyles} px-3 relative`}
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenComment();
                  }}
                  title="Comments"
                  disabled={submittingToAM}
                >
                  <div className="flex items-center gap-1 px-4 py-2 space-between">
                    <FiMessageCircle size={20} className="mph-primary" />
                  </div>
                </button>

                {/* Badge */}
                {candidate.comment_count > 0 && (
                  <span className="absolute -top-2 -right-2 bg-emerald-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-semibold">
                    {candidate.comment_count}
                  </span>
                )}
              </div>
              <button
                className={iconButtonStyles}
                type="button"
                onClick={handleOpenFormattedCVTypeModal}
                title="Formatted CV"
                disabled={submittingToAM || formattedCVLoading || resumeLoading}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=" fill-white mph-primary lucide lucide-file-check-corner-icon lucide-file-check-corner"
                >
                  <path d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                  <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                  <path d="m14 20 2 2 4-4" />
                </svg>
              </button>
            {candidate?.resume_status !== 'UNDER REVIEW' &&
                candidate?.resume_status !== 'VALIDATION_FAILED' && (
              <button
                className={`flex items-center gap-2 text-xs font-semibold text-gray-666 border border-gray-200 px-2.5 py-1.5 rounded-full ml-2 profiler-bg ${
                  disableSubmitToAM || submittingToAM
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                disabled={
                  disableSubmitToAM ||
                  submittingToAM ||
                  isAllJobsLoading ||
                  (isMatchingPage && candidate?.is_submitted)
                }
                onClick={(e) => {
                  e.stopPropagation();
                  if (!submittingToAM) handleConfirmSubmitToAM();
                }}
                title={
                  isAllJobsLoading
                    ? "Loading..."
                    : submittingToAM && !showJobsModal
                    ? "Submitting..."
                    : !isMatchingPage
                    ? "Submit to AM"
                    : candidate?.is_submitted
                    ? "Submitted"
                    : "Submit to AM"
                }
                type="button"
              >
                <FaUserCheck />{" "}
                {isTyping
                  ? null
                  : isAllJobsLoading
                  ? "Loading..."
                  : submittingToAM && !showJobsModal
                  ? "Submitting..."
                  : !isMatchingPage
                  ? "Submit to AM"
                  : candidate?.is_submitted
                  ? "Submitted"
                  : "Submit to AM"}
              </button>
              )}
            </div>
            <div className="flex items-center gap-2 p-2">
              {isMatchingPage && candidate?.viewed_at && (
                <div className="text-xs text-gray-666">
                  Viewed at : {formatDate(candidate?.viewed_at)}
                </div>
              )}
              {isMatchingPage && (
                <button
                  className={iconButtonStyles}
                  onClick={handleBookmarkClick}
                  disabled={bookmarkLoading || submittingToAM}
                  title={isBookmarked ? "Remove tag" : "Tag candidate"}
                >
                  {/* Loader should show while bookmarkLoading is true */}
                  {bookmarkLoading ? (
                    <span className="flex items-center">
                      <svg
                        className="animate-spin h-4 w-4 text-gray-400 inline-block"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        ></path>
                      </svg>
                    </span>
                  ) : isBookmarked ? (
                    <FaBookmarkFilled className="mph-primary" size={16} />
                  ) : (
                    <FiBookmark className="mph-primary" size={16} />
                  )}
                </button>
              )}
            </div>
            <div>
              <span>{isResumeUnderReview && (<span className="text-[10px] text-gray-500">Disclaimer: This resume was processed using AI. Please verify details for accuracy.</span>)}</span>
            </div>
          </div>


          {validationError && (
            <div className="mt-2 text-xs text-red-600 font-semibold px-2">
              {validationError}
            </div>
          )}
        </>
      )}

      {showFillModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 50,
            background: "rgba(0,0,0,0.25)",
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            style={{ position: "relative", zIndex: 60 }}
            onClick={(e) => e.stopPropagation()}
          >
            <FillMandatoryFieldsModal
              isOpen={showFillModal}
              onClose={handleCloseFillModal}
              candidate={resumeCandidateData}
              mph_jobid={mphJobId}
            />
          </div>
        </div>
      )}

      {showResumeModal && (
        <ResumeModal
          isOpen={showResumeModal}
          onClose={handleCloseResume}
          title={[candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`]
          .filter(Boolean)
          .join(' ') + ' - Resume'}
          resumeUrl={resumeUrl}
          loading={resumeLoading}
          error={resumeError}
          filetype={resumeFileType}
        />
      )}

      {showEmailModal && (
        <EmailModal
          isOpen={showEmailModal}
          onClose={handleCloseEmail}
          candidateName={candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
          candidateId={candidate?.id}
          candidateEmail={candidate.email}
          jobDuration={
            jobDetails?.mph_contractduration ||
            jobDetails?.contract_duration ||
            ""
          }
          jobTitle={jobDetails?.title || ""}
          jobOpeningDate={
            jobDetails?.mph_expctdstrtdate ||
            jobDetails?.expected_start_date ||
            ""
          }
          jobLocation={jobDetails?.mph_city || jobDetails?.city || ""}
          mphJobId={jobDetails?.mph_jobid}
          isEmailSent={
            emailType === "generic"
              ? Boolean(
                candidateData?.generic_email_sent_at ??
                candidate?.generic_email_sent_at ??
                candidateData?.email_sent_at ??
                candidate?.email_sent_at,
              )
              : candidateData?.is_email_sent ||
              Boolean(candidateData?.email_sent_at ?? candidate?.email_sent_at) ||
              false
          }
          emailSentOn={
            emailType === "generic"
              ? candidateData?.generic_email_sent_at ??
              candidate?.generic_email_sent_at ??
              candidateData?.email_sent_at ??
              candidate?.email_sent_at ??
              ""
              : candidateData?.email_sent_at ?? candidate?.email_sent_at ?? ""
          }
          emailSentBy={
            emailType === "generic"
              ? candidateData?.generic_email_sent_by ??
              candidate?.generic_email_sent_by ??
              candidateData?.email_sent_by ??
              candidate?.email_sent_by ??
              null
              : candidateData?.email_sent_by ??
              candidate?.email_sent_by ??
              candidateData?.generic_email_sent_by ??
              candidate?.generic_email_sent_by ??
              null
          }
          emailSentByFirstName={
            emailType === "generic"
              ? candidateData?.generic_email_sent_by_first_name ??
              candidate?.generic_email_sent_by_first_name ??
              candidateData?.email_sent_by_first_name ??
              candidate?.email_sent_by_first_name ??
              null
              : candidateData?.email_sent_by_first_name ??
              candidate?.email_sent_by_first_name ??
              candidateData?.generic_email_sent_by_first_name ??
              candidate?.generic_email_sent_by_first_name ??
              null
          }
          emailSentByLastName={
            emailType === "generic"
              ? candidateData?.generic_email_sent_by_last_name ??
              candidate?.generic_email_sent_by_last_name ??
              candidateData?.email_sent_by_last_name ??
              candidate?.email_sent_by_last_name ??
              null
              : candidateData?.email_sent_by_last_name ??
              candidate?.email_sent_by_last_name ??
              candidateData?.generic_email_sent_by_last_name ??
              candidate?.generic_email_sent_by_last_name ??
              null
          }
          emailSentByEmail={
            emailType === "generic"
              ? candidateData?.generic_email_sent_by_email ??
              candidate?.generic_email_sent_by_email ??
              candidateData?.email_sent_by_email ??
              candidate?.email_sent_by_email ??
              null
              : candidateData?.email_sent_by_email ??
              candidate?.email_sent_by_email ??
              candidateData?.generic_email_sent_by_email ??
              candidate?.generic_email_sent_by_email ??
              null
          }
          jobId={jobDetails?.id || ""}
          type={emailType}
          onSend={(data) => {
            if (emailType === "generic") {
              handleSendSearchEmail(data);
            } else {
              handleSendEmail(data);
            }
          }}
          sending={sendingEmail}
          sent={emailSent}
          error={emailError}
        />
      )}

      {showResumeEditModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 anim-slideDown resume-edit-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="w-11/12 md:w-5/6 lg:w-4/5 xl:w-3/4 max-h-[90vh] bg-white rounded-2xl shadow-lg relative p-6 flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-3 right-4 text-gray-666 hover:text-gray-700 text-2xl disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={handleResumeEditClose}
              disabled={resumeEditSaving}
              type="button"
            >
              &times;
            </button>
            <p className="text-xs mph-primary mb-4">
              Please verify and edit the candidate details before saving.
            </p>
            <div className="pr-1 max-h-[65vh]">
              {resumeEditLoading ? (
              <div className="py-8">
                <div className="text-sm text-gray-600">Loading candidate details...</div>
              </div>
            ) : (
              <div className="shadow-sm p-4">
                {resumeEditError && !isSectorRequiredError && (
                  <div className="mb-3 text-sm text-red-600">{resumeEditError}</div>
                )}
                <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-3 gap-y-5 gap-x-4 text-sm">
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Email ID</p>
                    <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
                      {resumeEditCandidate?.email || "-"}
                    </p>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Contact Number</p>
                    <input
                      type="text"
                      value={resumeEditForm.phone}
                      onChange={(e) => handleResumeEditFieldChange("phone", e.target.value)}
                      maxLength={15}
                      className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs mt-1"
                      placeholder="Enter phone number"
                      disabled={resumeEditSaving}
                    />
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Gender</p>
                    <div className={`mt-1 ${resumeEditSaving ? "pointer-events-none opacity-70" : ""}`}>
                      <CustomDropdown
                        options={GENDER_OPTIONS}
                        value={resumeEditForm.gender}
                        onChange={(value) => handleResumeEditFieldChange("gender", value)}
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select gender"
                        searchable={false}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Current Location</p>
                    <div className={`mt-1 ${resumeEditSaving ? "pointer-events-none opacity-70" : ""}`}>
                      <CustomDropdown
                        options={countryGuidOptions}
                        value={resumeEditForm.location}
                        onChange={(value) => handleResumeEditFieldChange("location", value)}
                        optionLabel="country_name"
                        optionValue="country_name"
                        placeholder={countryGuidLoading ? "Loading locations..." : "Select location"}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Nationality</p>
                    <div className={`mt-1 ${resumeEditSaving ? "pointer-events-none opacity-70" : ""}`}>
                      <CustomDropdown
                        options={countryGuidOptions}
                        value={resumeEditForm.nationality}
                        onChange={(value) => handleResumeEditFieldChange("nationality", value)}
                        optionLabel="country_name"
                        optionValue="country_name"
                        placeholder={countryGuidLoading ? "Loading nationalities..." : "Select nationality"}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Languages Known</p>
                    <div className={`mt-1 ${resumeEditSaving ? "pointer-events-none opacity-70" : ""}`}>
                      <CustomDropdown
                        options={languages?.data || []}
                        value={resumeEditForm.languages}
                        onChange={(value) => handleResumeEditFieldChange("languages", value)}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={languages?.loading ? "Loading languages..." : "Select languages"}
                        isMulti={true}
                        compactMultiDisplay={true}
                        multiDisplayLimit={2}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">
                      Sector <span className="text-red-500">*</span>
                    </p>
                    {isSectorRequiredError && (
                      <div className="mt-1 text-[10px] text-red-600">{resumeEditError}</div>
                    )}
                    <div className={`mt-1 ${resumeEditSaving ? "pointer-events-none opacity-70" : ""}`}>
                      <CustomDropdown
                        options={sectors?.data || []}
                        value={resumeEditForm.sectors}
                        onChange={(value) => handleResumeEditFieldChange("sectors", value)}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={sectors?.loading ? "Loading sectors..." : "Select sectors"}
                        isMulti={true}
                        compactMultiDisplay={true}
                        multiDisplayLimit={2}
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-[11px] tracking-wider font-semibold text-gray-400">Date of Birth</p>
                    <input
                      type="date"
                      value={resumeEditForm.date_of_birth || ""}
                      onChange={(e) => handleResumeEditFieldChange("date_of_birth", e.target.value)}
                      max={todayDateForInput}
                      className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs mt-1"
                      disabled={resumeEditSaving}
                    />
                  </div>
                </div>
              </div>
            )}
            </div>
            <div className="bg-white pt-3 mt-3 flex justify-end gap-2 border-gray-100">
              <button
                className="px-4 py-2 rounded-2xl bg-gray-200 text-gray-700 text-xs font-semibold shadow border border-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleResumeEditClose}
                disabled={resumeEditSaving}
                type="button"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-2xl text-white text-xs font-semibold shadow disabled:opacity-50 bg-[#B2853D] hover:bg-[#B2853D]"
                onClick={handleResumeEditSave}
                disabled={resumeEditSaving || resumeEditLoading}
                type="button"
              >
                {resumeEditSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showFormattedCVTypeModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
          onClick={handleCloseFormattedCVTypeModal}
        >
          <div
            className="w-[min(92vw,320px)] rounded-xl bg-white p-4 shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between gap-3 border-b border-gray-100 pb-3">
              <h3 className="text-sm font-semibold text-gray-800">Select CV type</h3>
              <button
                type="button"
                className="text-gray-500 hover:text-gray-800"
                onClick={handleCloseFormattedCVTypeModal}
                aria-label="Close formatted CV type modal"
              >
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M6 6L14 14M14 6L6 14"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-2">
              {FORMATTED_CV_TYPES.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className="w-full rounded-lg border border-gray-200 px-4 py-3 text-left text-sm font-semibold text-gray-700 transition-colors hover:border-emerald-500 hover:bg-emerald-50 hover:text-emerald-700"
                  onClick={(e) => handleShowCVModal(option.value, e)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {showCVModal && (
        <div className={modalContainerClass + " cv-modal anim-slideDown"}>
          <div
            className={`bg-white rounded-xl shadow-lg ${modalPaddingClass} ${modalSizeClass} relative transition-all duration-200`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 pb-3">
                <button
                  onClick={handleCloseCVModal}
                  className="flex items-center text-xs "
                  aria-label="Go back"
                >
                  <svg
                    className="w-4 h-4 "
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={3}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Candidate
                </button>
              </div>
              {expanded ? (
                <div className="flex gap-2">
                  <button
                    className="px-3 py-1.5 rounded-full text-xs font-semibold border border-gray-200 bg-gray-200 hover:bg-gray-200"
                    onClick={handleCloseCVModal}
                    type="button"
                  >
                    Close
                  </button>
                </div>
              ) : (
                <button
                  className="top-2 right-2 text-gray-600 hover:text-gray-900 bg-gray-100 rounded-full p-1"
                  onClick={handleCloseCVModal}
                  type="button"
                  aria-label="Close CV modal"
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M6 6L14 14M14 6L6 14"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              )}
            </div>
            <div className={gridColsClass}>
              <div>
                <div className="font-semibold text-gray-666 mb-2 text-sm flex items-center gap-1">
                  Original CV
                  {/* {resumeUrl && (
                    <button
                      type="button"
                      onClick={() => handleViewResumeClick()}
                      disabled={viewLoading}
                      aria-label="View Original CV in new tab"
                      className="ml-1 inline-flex items-center disabled:opacity-50"
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        viewBox="0 0 24 24"
                        className="inline-block align-middle text-gray-666"
                      >
                        <path
                          d="M14 3h7m0 0v7m0-7L10 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <rect
                          x="5"
                          y="5"
                          width="14"
                          height="14"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>
                  )} */}
                  {resumeUrl && (
                    <button
                      type="button"
                      onClick={() => handleDownloadResumeClick()}
                      disabled={viewLoading}
                      aria-label="Download Original CV in new tab"
                      className="ml-1 inline-flex items-center disabled:opacity-50"
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 14.25C3.41421 14.25 3.75 14.5858 3.75 15C3.75 16.4354 3.75159 17.4365 3.85315 18.1919C3.9518 18.9257 4.13225 19.3142 4.40901 19.591C4.68577 19.8678 5.07435 20.0482 5.80812 20.1469C6.56347 20.2484 7.56459 20.25 9 20.25H15C16.4354 20.25 17.4365 20.2484 18.1919 20.1469C18.9257 20.0482 19.3142 19.8678 19.591 19.591C19.8678 19.3142 20.0482 18.9257 20.1469 18.1919C20.2484 17.4365 20.25 16.4354 20.25 15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V15.0549C21.75 16.4225 21.75 17.5248 21.6335 18.3918C21.5125 19.2919 21.2536 20.0497 20.6517 20.6516C20.0497 21.2536 19.2919 21.5125 18.3918 21.6335C17.5248 21.75 16.4225 21.75 15.0549 21.75H8.94513C7.57754 21.75 6.47522 21.75 5.60825 21.6335C4.70814 21.5125 3.95027 21.2536 3.34835 20.6517C2.74643 20.0497 2.48754 19.2919 2.36652 18.3918C2.24996 17.5248 2.24998 16.4225 2.25 15.0549C2.25 15.0366 2.25 15.0183 2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z"
                          fill="#1C274C"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12 16.75C12.2106 16.75 12.4114 16.6615 12.5535 16.5061L16.5535 12.1311C16.833 11.8254 16.8118 11.351 16.5061 11.0715C16.2004 10.792 15.726 10.8132 15.4465 11.1189L12.75 14.0682V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V14.0682L8.55353 11.1189C8.27403 10.8132 7.79963 10.792 7.49393 11.0715C7.18823 11.351 7.16698 11.8254 7.44648 12.1311L11.4465 16.5061C11.5886 16.6615 11.7894 16.75 12 16.75Z"
                          fill="#1C274C"
                        />
                      </svg>
                    </button>
                  )}
                </div>
                <div className={`w-full ${iframeHeightClass} border rounded`}>
                  {resumeUrl ? (
                    <iframe
                      src={
                        resumeUrl.toLowerCase().split("?")[0].endsWith(".docx")
                          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                              resumeUrl.trim().replace(/ /g, "%20")
                            )}`
                          : resumeUrl
                      }
                      className="w-full h-full border-0"
                      title="Original CV"
                      style={{ backgroundColor: "white" }}
                    />
                  ) : (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                      Not available
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className="font-semibold text-gray-666 mb-2 text-sm flex items-center gap-1">
                  Formatted CV
                  {formattedCVUrl && (
                    <button
                      type="button"
                      onClick={() => handleViewFormattedResumeClick()}
                      disabled={viewLoading}
                      aria-label="View Formatted CV in new tab"
                      className="ml-1 inline-flex items-center disabled:opacity-50"
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="none"
                        viewBox="0 0 24 24"
                        className="inline-block align-middle text-gray-666"
                      >
                        <path
                          d="M14 3h7m0 0v7m0-7L10 14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <rect
                          x="5"
                          y="5"
                          width="14"
                          height="14"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>
                  )}
                  {formattedCVUrl && (
                    <button
                      type="button"
                      onClick={() => handleDownloadFormattedResumeClick()}
                      disabled={viewLoading}
                      aria-label="Download Formatted CV"
                      className="ml-1 inline-flex items-center disabled:opacity-50"
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.5"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 14.25C3.41421 14.25 3.75 14.5858 3.75 15C3.75 16.4354 3.75159 17.4365 3.85315 18.1919C3.9518 18.9257 4.13225 19.3142 4.40901 19.591C4.68577 19.8678 5.07435 20.0482 5.80812 20.1469C6.56347 20.2484 7.56459 20.25 9 20.25H15C16.4354 20.25 17.4365 20.2484 18.1919 20.1469C18.9257 20.0482 19.3142 19.8678 19.591 19.591C19.8678 19.3142 20.0482 18.9257 20.1469 18.1919C20.2484 17.4365 20.25 16.4354 20.25 15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V15.0549C21.75 16.4225 21.75 17.5248 21.6335 18.3918C21.5125 19.2919 21.2536 20.0497 20.6517 20.6516C20.0497 21.2536 19.2919 21.5125 18.3918 21.6335C17.5248 21.75 16.4225 21.75 15.0549 21.75H8.94513C7.57754 21.75 6.47522 21.75 5.60825 21.6335C4.70814 21.5125 3.95027 21.2536 3.34835 20.6517C2.74643 20.0497 2.48754 19.2919 2.36652 18.3918C2.24996 17.5248 2.24998 16.4225 2.25 15.0549C2.25 15.0366 2.25 15.0183 2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z"
                          fill="#1C274C"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12 16.75C12.2106 16.75 12.4114 16.6615 12.5535 16.5061L16.5535 12.1311C16.833 11.8254 16.8118 11.351 16.5061 11.0715C16.2004 10.792 15.726 10.8132 15.4465 11.1189L12.75 14.0682V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V14.0682L8.55353 11.1189C8.27403 10.8132 7.79963 10.792 7.49393 11.0715C7.18823 11.351 7.16698 11.8254 7.44648 12.1311L11.4465 16.5061C11.5886 16.6615 11.7894 16.75 12 16.75Z"
                          fill="#1C274C"
                        />
                      </svg>
                    </button>
                  )}
                </div>
                <div className={`w-full ${iframeHeightClass} border rounded`}>
                  {formattedCVLoading ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600 mb-2"></div>
                      Loading formatted CV...
                    </div>
                  ) : formattedCVError ? (
                    <div className="flex flex-col items-center justify-center h-full text-red-500 text-sm">
                      {formattedCVError}
                    </div>
                  ) : formattedCVUrl ? (
                    <iframe
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        formattedCVUrl
                      )}`}
                      title="Formatted CV"
                      className="w-full h-full rounded"
                      frameBorder="0"
                      allowFullScreen
                    />
                  ) : (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                      Not available
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <CommentModal
        isOpen={showCommentModal}
        comment={comment}
        setComment={setComment}
        onSave={handleSaveComment}
        onClose={handleCloseComment}
        candidateId={candidate.id}
        onUpdateCandidate={handleUpdateComment}
      />

      {savedComment && (
        <div className="mt-2 text-xs text-gray-700 mph-light rounded p-2">
          <span className="font-semibold mph-primary">Comment:</span>{" "}
          {savedComment}
        </div>
      )}
      {showJobsModal && (
        <JobSelectionModal
          currentJobs={currentJobs}
          setSelectedJob={(job) => {
            setSelectedJobForApplicant(job);
            setMphJobId(job?.mph_jobid);
          }}
          onClose={() => {
            setSelectedJobForApplicant("");
            setShowJobsModal(false);
          }}
          isOpen={showJobsModal}
          handleSubmit={handleSubmitWithMandatoryFields}
          selectedJob={selectedJobForApplicant}
        />
      )}
      {showWhatsAppModal && (
        <>
          {console.log("Candidate:", user)}
         <WhatsAppModal
              isOpen={showWhatsAppModal}
              onClose={() => setShowWhatsAppModal(false)}
              onSend={sendWhatsappMsg}
              recruiterName={toTitleCase(user?.displayName)}
              candidateName={candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
              jobDetails={jobDetails}
              templateMessage={getWhatsAppTemplateMessage()}
              sending={sendingWhatsApp}
              recruiterId={user?.id}
              notifications={candidateData?.whatsapp_notifications || []}
              candidateId={candidate?.id}
            />
        </>
      )}
    </div>
  );
};
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export default CandidateItem;





function SmartTooltip({ children, content }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const handleMouseEnter = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const isBelow3Quarters = rect.top > window.innerHeight * 0.75;

      setPos({
        x: rect.left + rect.width / 2,
        y: isBelow3Quarters ? rect.top - 8 : rect.bottom + 8,
        above: isBelow3Quarters,
      });
    }
  };

  const handleMouseLeave = () => setPos(null);

  return (
    <div ref={ref} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="relative">
      {children}

      {pos && createPortal(
        <div
          style={{
            position: "fixed",
            left: pos.x,
            top: pos.y,
            transform: pos.above ? "translate(-50%, -100%)" : "translate(-50%, 0%)",
            zIndex: 9999,
            pointerEvents: "none",
          }}
          className="whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white text-left shadow-lg"
        >
          {content}
        </div>,
        document.body
      )}
    </div>
  );
}
